import type { TourDefinition } from '@renderer/hooks/useTour';

export const tourDespacho: TourDefinition = {
  id: 'despacho',
  title: 'Cómo gestionar el despacho',
  steps: [
    {
      element: '[data-tour="dsp-header"]',
      popover: {
        title: '1. Estado del despacho',
        description:
          'Esta pantalla es solo para pedidos a domicilio (delivery). El encabezado muestra cuántos están listos, en ruta y pendientes de cobro.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="dsp-listos"]',
      popover: {
        title: '2. Listos para despachar',
        description:
          'Pedidos que cocina ya terminó. Asígnale un repartidor y toca "Despachar" para que salgan a ruta.',
        side: 'right',
      },
    },
    {
      element: '[data-tour="dsp-en-ruta"]',
      popover: {
        title: '3. En ruta y pendientes de cobro',
        description:
          '"En ruta" son los que ya salieron. Cuando el repartidor regresa, márcalo como entregado. Los entregados sin cobrar aparecen en "Pendiente cobro".',
        side: 'left',
      },
    },
  ],
};
